import React from 'react'

const StatsBar = ({ boxes, className, ...otherProps }) => (
  <div className={`StatsBar ${className || ''}`} {...otherProps}>
    {!!boxes && boxes.map((box, i) => <StatBox {...box} key={i} />)}
  </div>
)

const StatBox = ({ title, value, color }) => (
  <div className={`StatBox ${color}`}>
    <div className='value'>{value}</div>
    <div className='title'>{title}</div>
  </div>
)

export default StatsBar
